import React, { createContext, useState,useContext } from 'react';
import { toast } from 'react-toastify';
import { apiPlanos } from '../services/api';
import { TokenContext } from './TokenContext';


export const PlanosContext = createContext([]);

export function PlanosProvider(props) {
	const { children, user } = props;
	const [maxParcelas, setMaxParcelas] =useState(0) ;

	const { autenticacaoV1Token } = useContext(TokenContext);
	async function authToken() {
		let result = null;
		try {
			result = await autenticacaoV1Token();
		} catch (e) {
			console.error(e);
		}
		return result;
	}
	/*
	async function authToken() {
		try {
			const credentials = {
				username: config.USER_AUTHENTICATION_DEV,
				password: config.USER_AUTHENTICATION_PASS_DEV,
			};
			const response = await apiLucree.post(
				'autenticacao/v1/',
				credentials
			);

			return response;
		} catch (error) {
			toast.error(
				'Os dados de autenticação de token não foram carregados. Por favor atualize a página'
			);
		}

		return null;
	}
	*/

	async function getMaxParcelasByUser(tokenData) {
		try {
			await apiPlanos.get(`maximo-parcela-plano/${user?.dados?.plano_id}/`,
				{
					headers: {
						'Content-Type': 'application/json',
						Authorization: `${tokenData}`,

					},
				}).then((res) => {
					if(res.data.maximoParcelas){
						setMaxParcelas(res.data.maximoParcelas)
					}
				})
		} catch (error) {
			toast.error(
				'Nenhuma Liquidação encontrada.'
			);
		}
		return null;
	}

	return (
		<PlanosContext.Provider
			value={{
				authToken,
				maxParcelas,
				getMaxParcelasByUser,
			}}>
			{children}
		</PlanosContext.Provider>
	);
}
